import { ChangeDetectionStrategy, Component, InjectionToken, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MdlDialogReference } from '@angular-mdl/core';
import { GridHeader, GridDetails } from '../../tracking-overview/interfaces/grid';
import { GroupTrackingGridData, DataRevisionInfo } from '../../filter-samples/filter-samples-info';
import { DynamicListColumnInfo } from '../../filter-samples/interface/dynamic-list-info';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
export const DATA_CHANGE_MODEL_TOKEN = new InjectionToken('DataChangeModelToken');
import * as moment from 'moment';

export interface DateChangeModel {
    data?: GroupTrackingGridData;
    selectedColumn?: GridHeader;
    dyanmicData?: DynamicListColumnInfo;
}

@Component({
    selector: 'data-change-model',
    template: require('./data-change-model.component.html'),
    styles: [require('./data-change-model.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataChangeModelComponent implements OnInit {

    public dataChangeInfo: any;
    public isLoadingCompleted = false;
    public gridDetails: GridDetails;
    public registrationSubmittedDate = '';

    constructor(
        private readonly dialogRef: MdlDialogReference,
        private changeDectectorRef: ChangeDetectorRef,
        private sampleTrackingStorage: SampleTrackingStorage,
        @Inject(DATA_CHANGE_MODEL_TOKEN) private readonly dataChangeModel: any) {

        this.dataChangeInfo = dataChangeModel;
    }

    public ngOnInit() {
        let url = this.dataChangeInfo.dyanmicData.hyperlinkRoute.trim().replace('{0}', this.dataChangeInfo.data[this.dataChangeInfo.dyanmicData.actionDbViewColumnName as keyof GroupTrackingGridData]);
        this.sampleTrackingStorage.getDataRevisionInfo(url).subscribe((dataRevisionInfo: DataRevisionInfo[]) => {
            this.gridDetails = { header: this.getGridHeader(), data: dataRevisionInfo };
            if (dataRevisionInfo && dataRevisionInfo.length) {
                this.registrationSubmittedDate = dataRevisionInfo[0].submittedOn ? moment(dataRevisionInfo[0].submittedOn).format('DD-MMM-YYYY') : '';
            }
            this.isLoadingCompleted = true;
            this.changeDectectorRef.markForCheck(); 
        });
    }

    public onCancel() {
        this.dialogRef.hide();
    }

    public getGridHeader(): GridHeader[] {
        return [
            {
                key: 'zcInvestigatorNumber',
                displayText: 'Investigator No. (current)'
            },
            {
                key: 'sstInvestigatorNumber',
                displayText: 'Investigator No. (submitted)'
            },
            {
                key: 'zcInvestigatorName',
                displayText: 'Investigator Name (current)'
            },
            {
                key: 'sstInvestigatorName',
                displayText: 'Investigator Name (submitted)'
            },
            {
                key: 'zcVisitDescription',
                displayText: 'Visit Description (current)'
            },
            {
                key: 'sstVisitDescription',
                displayText: 'Visit Description (submitted)'
            },
            {
                key: 'zcProtocolVisitCode',
                displayText: 'Protocol Visit Code (current)'
            },
            {
                key: 'sstProtocolVisitCode',
                displayText: 'Protocol Visit Code (submitted)'
            }
        ];
    }

}